import { Guid } from "@/Common/Models/Guid";

enum ClickToDialViewMode {
    Hyperlink
}

interface SendClickToDialResponse {
    DialSuccess: boolean
}

interface SendClickToDialRequest {
    PhoneNumber: string,
    PatientContactId?: Guid
    PatientContactFacetId?: Guid
}

interface IClickToDialProps {
    viewMode: ClickToDialViewMode
    className?: string
    onSuccessfulDial?: () => void,
    patientContactFacetId?: Guid,
    patientContactId?: Guid,
    forActivePatient?: boolean
}

export {
    ClickToDialViewMode,
    IClickToDialProps,
    SendClickToDialRequest,
    SendClickToDialResponse
};
